export default class SmsListPageController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');

        this._initStore();
    }

    _initStore() {
        this.store = this.injector.get('Messages').reset({
            persist: true,
            listname: 'SentSmsListview'
        });
        this.store.commit('setVm', this);
        // this.store.commit('setPermanentFilters', {
        //     type: 'sms'
        // });
        this.store.commit('setTitle', this.translate.instant(`messages.controllers.pages.sms.list.title`))
        this.store.dispatch('loadWorkflows', 'messages::list');
    }
}

SmsListPageController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/sms/list.js